// Research & Development page Indonesian translations

export default {
  pageTitle: "Penelitian & Pengembangan",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Penelitian & Pengembangan",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Penelitian & Pengembangan Inovatif",
  description1: "Di PT Eagle Industry Indonesia, tim Penelitian & Pengembangan kami mendorong inovasi yang memposisikan kami di garis depan teknologi pengecatan. Kami berinvestasi secara signifikan dalam R&D untuk mengembangkan solusi canggih yang mengatasi tantangan industri yang berkembang, meningkatkan kinerja, dan menciptakan kemungkinan baru untuk pelanggan kami di berbagai sektor.",
  description2: "Pendekatan R&D kami menggabungkan penelitian fundamental dengan pengembangan aplikasi praktis, memastikan bahwa inovasi kami tidak hanya canggih secara teknis tetapi juga layak secara komersial dan dapat diterapkan segera pada tantangan dunia nyata. Kami berkolaborasi erat dengan pelanggan, institusi akademis, dan mitra industri untuk mengidentifikasi kebutuhan yang muncul dan mengembangkan solusi yang melampaui ekspektasi.",
  
  // Focus areas section
  focusTitle: "Area Fokus R&D Kami:",
  focusAreas: [
    "Pengembangan material canggih untuk daya tahan dan kinerja yang ditingkatkan",
    "Optimasi desain pengecatan untuk efisiensi dan umur panjang yang ditingkatkan",
    "Solusi pengecatan cerdas dengan kemampuan pemantauan terintegrasi",
    "Teknologi pengecatan yang ramah lingkungan",
    "Solusi aplikasi suhu tinggi dan tekanan tinggi",
    "Material ringan untuk aplikasi otomotif dan dirgantara",
    "Simulasi digital dan pemodelan prediktif untuk validasi desain"
  ],
  
  // Research facilities section
  facilitiesTitle: "Fasilitas Penelitian:",
  facilitiesDescription: "Fasilitas R&D mutakhir kami dilengkapi dengan peralatan pengujian canggih, laboratorium analisis material, dan kemampuan prototyping. Sumber daya ini memungkinkan tim penelitian kami untuk melakukan pengujian komprehensif di bawah kondisi operasi simulasi, memvalidasi desain baru, dan mempercepat siklus pengembangan sambil mempertahankan standar kualitas yang ketat.",
  
  // Metrics
  innovationPipeline: "Alur Inovasi",
  innovationPipelineDesc: "Pengembangan berkelanjutan solusi pengecatan generasi berikutnya",
  technicalExpertise: "Keahlian Teknis",
  technicalExpertiseDesc: "Tim R&D khusus dengan latar belakang teknik yang beragam",
  collaborationNetwork: "Jaringan Kolaborasi",
  collaborationNetworkDesc: "Kemitraan dengan institusi penelitian dan pemimpin industri",
  technologyTransfer: "Transfer Teknologi",
  technologyTransferDesc: "Integrasi efektif temuan penelitian ke dalam produksi",
  
  // Development process section
  processTitle: "Proses Pengembangan:",
  processDescription: "Pengembangan produk kami mengikuti proses terstruktur yang dimulai dengan penelitian pasar dan penilaian kebutuhan, diikuti dengan pengembangan konsep, prototyping, pengujian, dan validasi. Kami menggunakan metodologi pengembangan agile untuk mempercepat inovasi sambil mempertahankan pengujian dan jaminan kualitas yang teliti pada setiap tahap pengembangan.",
  
  // Intellectual property section
  ipTitle: "Kekayaan Intelektual:",
  ipDescription: "Kami secara aktif melindungi inovasi kami melalui paten dan hak kekayaan intelektual, memastikan bahwa keuntungan teknologis kami bermanfaat bagi pelanggan kami. Portofolio paten kami mencakup berbagai inovasi dalam teknologi pengecatan, ilmu material, dan proses manufaktur yang menyediakan keuntungan kompetitif bagi mitra kami.",
  
  // Future research section
  futureTitle: "Arah Penelitian Masa Depan:",
  futureDescription: "Melihat ke masa depan, upaya R&D kami semakin fokus pada teknologi berkelanjutan, digitalisasi sistem pengecatan, dan solusi untuk aplikasi yang muncul dalam energi terbarukan, kendaraan listrik, dan manufaktur lanjutan. Kami berkomitmen untuk mengembangkan teknologi pengecatan yang berkontribusi pada masa depan industri yang lebih berkelanjutan dan efisien.",
  
  // CTA button
  discussRAndD: "Diskusikan Kolaborasi R&D",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  customManufacturingDesc: "Solusi manufaktur yang disesuaikan untuk memenuhi persyaratan pelanggan spesifik.",
  qualityAssuranceDesc: "Proses kontrol kualitas ketat memastikan kepatuhan standar internasional.",
  technicalSupportDesc: "Bantuan teknis ahli untuk memastikan kinerja produk optimal.",
  readMore: "Baca selengkapnya"
};